import { combineReducers } from 'redux';
import {orderReducer} from './order-reducer';
import {brokerReducer} from './broker-reducer';
import {locationReducer} from './location-reducer';
import {loginReducer} from './login-reducer';
import {registrationReducer} from './registration-reducer';
import { demoRequestReducer } from './demo-request-reducer';
import {driverReducer} from './driver-reducer';
import {equipmentReducer} from './equipment-reducer';
import {tenantReducer} from './tenant-reducer';
import {reportReducer} from './report-reducer';
import {invoiceReducer} from './invoice-reducer';
import {billReducer} from './bill-reducer';
import { schedulerReducer } from './scheduler-reducer';
/* OTR */
import { otrOrderReducer } from './otr/otr-order-reducer'; 
import { truckReducer } from './truck-reducer';
import { globalToastReducer } from './global-toast-reducer';

const RootReducer = combineReducers({
  orderReducer,
  brokerReducer,
  locationReducer,
  loginReducer,
  registrationReducer,
  demoRequestReducer,
  driverReducer,
  equipmentReducer,
  truckReducer,
  tenantReducer,
  reportReducer,
  invoiceReducer,
  billReducer,
  schedulerReducer,
  otrOrderReducer,
  globalToastReducer,
});

export default RootReducer;